import React from "react";
import {
  getCuadroExtendedDeduccionesColSpan,
  getCuadroExtendedPercepcionesGroupColSpan,
} from "../../utils/cuadroExtendedBreakdown.ts";
import {
  PayrollSubHeaderCell,
  payrollGroupHeaderStyle,
} from "./PayrollHeader.tsx";

export type PayrollExtendedHeaderProps = {
  bonusColumns: string[];
  deductionColumns: string[];
};

function PairCols({
  qtyLabel,
  moneyLabel,
}: {
  qtyLabel: string;
  moneyLabel: string;
}) {
  return (
    <>
      <PayrollSubHeaderCell label={qtyLabel} />
      <PayrollSubHeaderCell label={moneyLabel} />
    </>
  );
}

const PayrollExtendedHeader = ({
  bonusColumns,
  deductionColumns,
}: PayrollExtendedHeaderProps) => {
  const percepcionesGroupColSpan =
    getCuadroExtendedPercepcionesGroupColSpan(bonusColumns.length);
  const deduccionesColSpan = getCuadroExtendedDeduccionesColSpan(
    deductionColumns.length
  );
  const finalGroupColSpan = 2;

  return (
    <thead className="text-center">
      <tr className="text-uppercase">
        <th
          colSpan={percepcionesGroupColSpan}
          className="align-middle"
          style={payrollGroupHeaderStyle("percepciones")}
        >
          Percepciones
        </th>
        <th
          colSpan={deduccionesColSpan}
          className="align-middle"
          style={payrollGroupHeaderStyle("deducciones")}
        >
          Deducciones
        </th>
        <th
          colSpan={2}
          className="align-middle"
          style={payrollGroupHeaderStyle("otros")}
        >
          Otros
        </th>
        <th
          colSpan={finalGroupColSpan}
          className="align-middle"
          style={payrollGroupHeaderStyle("final")}
        >
          Final
        </th>
      </tr>
      <tr>
        <PayrollSubHeaderCell label="Chilito" />
        <PayrollSubHeaderCell label="Sueldo base 15" />
        <PayrollSubHeaderCell label="Salario diario" />
        <PayrollSubHeaderCell label="Sueldo x hora" />
        <PairCols qtyLabel="Jornadas compl." moneyLabel="$ Jornadas" />
        <PairCols qtyLabel="Horas trabajadas" moneyLabel="$ Horas trab." />
        <PairCols qtyLabel="Días vacaciones" moneyLabel="$ Vacaciones" />
        <PayrollSubHeaderCell label="Prima vacacional" />
        <PairCols qtyLabel="Días incapacidad" moneyLabel="$ Incapacidad" />
        <PairCols qtyLabel="Horas extras" moneyLabel="$ H. extras" />
        <PairCols qtyLabel="Turnos dobles" moneyLabel="$ T. dobles" />
        <PairCols qtyLabel="Descansos trab." moneyLabel="$ Desc. trab." />
        <PairCols qtyLabel="Días festivos" moneyLabel="$ Festivo" />
        {bonusColumns.map((label) => (
          <PayrollSubHeaderCell key={`bonus-${label}`} label={label} />
        ))}
        <PayrollSubHeaderCell label="Total ingresos" />
        {deductionColumns.map((label) => (
          <PayrollSubHeaderCell key={`ded-${label}`} label={label} />
        ))}
        <PayrollSubHeaderCell label="Total descuentos" />
        <PayrollSubHeaderCell label="Pago con tarjeta" />
        <PayrollSubHeaderCell label="Efectivo a pagar" />
        <PayrollSubHeaderCell label="Total a pagar" />
        <PayrollSubHeaderCell label="Detalles" />
      </tr>
    </thead>
  );
};

export default PayrollExtendedHeader;
